import styled from 'styled-components'
import { Tabs, Tab, Box, TextField, InputAdornment } from '@mui/material'
import { useLocation, NavLink } from 'react-router-dom'
import { FormattedMessage, useIntl } from 'react-intl'
import LinkButton from 'components/ui/LinkButton'
import { ClientRoute } from 'routes/client'
import SearchIcon from '@mui/icons-material/Search'

interface Props {
  children: JSX.Element
  handleSearchChange: (e: any) => void
}

export default function ChallengesContainer({ children, handleSearchChange }: Props): JSX.Element {
  const location = useLocation()
  const intl = useIntl()

  return (
    <PageContainer>
      <ActionContainer
        style={{
          width: 'fit-content',
          minWidth: 'calc(100vw - 250px)',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <TabContainer value={location.pathname}>
          <Tab
            component={NavLink}
            to={ClientRoute.ADMIN_CHALLENGES}
            value={ClientRoute.ADMIN_CHALLENGES}
            label={<FormattedMessage id="strings.current" />}
            style={{
              fontWeight: 700,
              fontSize: 15,
            }}
          />
          <Tab
            component={NavLink}
            to={ClientRoute.ADMIN_CHALLENGES_PAST}
            value={ClientRoute.ADMIN_CHALLENGES_PAST}
            label={<FormattedMessage id="strings.past" />}
            style={{
              fontWeight: 700,
              fontSize: 15,
            }}
          />
        </TabContainer>

        <Box
          sx={{ display: 'flex', alignItems: 'center', gap: '8px', ml: 'auto', width: '50%', justifyContent: 'end' }}
        >
          <TextField
            type="text"
            name="search"
            placeholder={intl.formatMessage({ id: 'strings.search' })}
            onChange={handleSearchChange}
            sx={{
              width: '60%',
              '& .MuiOutlinedInput-root': {
                backgroundColor: '#fff',
                borderRadius: '8px',
                boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',

                '& fieldset': {
                  borderColor: '#e4e4e7',
                },

                '&:hover fieldset': {
                  borderColor: '#e4e4e7',
                },

                '&.Mui-focused fieldset': {
                  borderColor: '#e4e4e7',
                },
              },

              '& .MuiOutlinedInput-input': {
                padding: '10px 12px',
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start" sx={{ mr: 0.5 }}>
                  <SearchIcon sx={{ color: '#8A8A8E' }} />
                </InputAdornment>
              ),
            }}
          />
          <LinkButton text={<FormattedMessage id="strings.createNew" />} to="/admin/challenges/new" />
        </Box>
      </ActionContainer>

      <Content>{children}</Content>
    </PageContainer>
  )
}

const PageContainer = styled.div`
  margin: 10px;
  padding: 10px 20px 20px;
  min-height: 500px;
  background-color: #fff;
`

const ActionContainer = styled.div`
  padding: 20px 0;
  display: flex;
  align-items: center;
  gap: 8px;
`

const TabContainer = styled(Tabs)`
  width: 50%;

  & .MuiTabs-indicator {
    background-color: ${(props) => props.theme.palette.primary.main};
    height: 3px;
  }

  & a {
    text-transform: none;

    &.active {
      color: ${(props) => props.theme.palette.primary.main};
    }
  }
`

const Content = styled.div`
  margin: 20px 0;
`
